import React from 'react';
import { Col, Row, Statistic, Tooltip } from 'antd';
import { ArrowDownCircle, ArrowUpCircle } from 'react-feather';
import { ContentWrapper, Group } from '@/components/_common';
import WorkOrdersListModal from '@/components/_common/WorkOrdersListModal';
import { useDisclosure } from '@/hooks';

interface Props {
  vehiclesEntryMonth: number;
  vehiclesReturnMonth: number;
}

const VehicleEntryAndExit = ({
  vehiclesEntryMonth,
  vehiclesReturnMonth,
}: Props) => {
  const [viewWorkOrdersEntriesOpen, viewWorkOrdersEntriesActions] =
    useDisclosure();
  const [viewWorkOrdersDeparturesOpen, viewWorkOrdersDeparturesActions] =
    useDisclosure();

  return (
    <>
      <Col span={24}>
        <Row gutter={[16, 16]}>
          <Col span={24} md={12}>
            <ContentWrapper
              style={{ padding: '14px' }}
              onClick={viewWorkOrdersEntriesActions.open}
            >
              <Tooltip
                title="Número de veículos que entraram este mês"
                className="header-statistic-action"
              >
                <Group gap={10}>
                  <ArrowDownCircle size={26} style={{ color: 'green' }} />

                  <Statistic
                    value={vehiclesEntryMonth || 0}
                    title="Entradas de veículos no mês"
                  />
                </Group>
              </Tooltip>
            </ContentWrapper>
          </Col>

          <Col span={24} md={12}>
            <ContentWrapper
              style={{ padding: '14px' }}
              onClick={viewWorkOrdersDeparturesActions.open}
            >
              <Tooltip
                title="Número de veículos que saíram este mês"
                className="header-statistic-action"
              >
                <Group gap={10}>
                  <ArrowUpCircle size={26} style={{ color: 'red' }} />

                  <Statistic
                    value={vehiclesReturnMonth || 0}
                    title="Saídas de veículos no mês"
                  />
                </Group>
              </Tooltip>
            </ContentWrapper>
          </Col>
        </Row>
      </Col>

      <WorkOrdersListModal
        open={viewWorkOrdersEntriesOpen}
        onCancel={viewWorkOrdersEntriesActions.close}
        queryFilter={{
          onlyVehicleEntriesTheMonth: true,
        }}
      />

      <WorkOrdersListModal
        open={viewWorkOrdersDeparturesOpen}
        onCancel={viewWorkOrdersDeparturesActions.close}
        queryFilter={{
          onlyVehicleDeparturesTheMonth: true,
        }}
      />
    </>
  );
};

export default VehicleEntryAndExit;
